import AboutUs from './AboutUs.vue'

export default AboutUs
